import { FC } from 'react';

import Card, {
  CardProps,
  SpacingProps,
} from '@deliveroo/tools-component-library/dist/components/Card';
import Icon from '@deliveroo/tools-component-library/dist/components/Icon';
import Text from '@deliveroo/tools-component-library/dist/components/Text';

import useI18n from 'lib/hooks/useI18n';
import I18n from 'lib/utils/i18n';

import * as styles from './styles.module.scss';

export interface ErrorBoxProps
  extends Omit<CardProps, 'children'>,
    SpacingProps {
  guid: string;
}

// When this component is used as a root error fallback, we have to assume that even i18n can fail.
// If that happens, use a static English translation
const staticError =
  "Sorry, we couldn't load the page. We're working on fixing it. Try refreshing your page or come back later.";

const getDefaultMessage = (i18n: I18n) => {
  const errorMessage = i18n.gettext('fallback_card.text');
  const hasTranslation = errorMessage && errorMessage !== 'fallback_card.text';

  return hasTranslation ? errorMessage : staticError;
};

const ErrorBox: FC<ErrorBoxProps> = ({ children, guid, ...cardProps }) => (
  <Card {...cardProps}>
    <div className={styles.errorCardBody}>
      <Icon
        name="error_outline"
        spacing="small 0 medium"
        size={36}
        color="light-grey"
      />
      {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
      {children ?? <Text color="grey">{getDefaultMessage(useI18n())}</Text>}
      <Text color="grey">{guid}</Text>
    </div>
  </Card>
);

export default ErrorBox;
